import { motion } from 'motion/react'
import { StaggerContainer, staggerItemVariants } from '../shared/StaggerContainer'
import AnimatedCounter from './AnimatedCounter'

export default function UsageStats({ stats }) {
    return (
        <StaggerContainer
            className="flex flex-col md:flex-row gap-8 text-center justify-center items-center"
        >
            {stats.map((stat, index) => (
                <motion.div key={index} variants={staggerItemVariants}>
                    <div
                        className="text-4xl font-semibold"
                        style={{
                            color: 'var(--color-primary-600)'
                        }}
                    >
                        <AnimatedCounter
                            end={stat.value}
                            duration={2}
                            suffix={stat.suffix}
                        />
                    </div>
                    <div className='text-base text-neutral-600'>
                        {stat.label}
                    </div>
                </motion.div>
            ))}
        </StaggerContainer>
    );
}